import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AirlineMasterProperties } from '../Models/AirlineMasterProperties';
import { ReportTypesAgency } from '../Models/AgencyMasterProperties';

@Injectable({
  providedIn: 'root'
})
export class AirlineMasterService {
  baseUrl = environment.baseUrl;
  backSystemBaseUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(private http: HttpClient) { }
  getAirlinesData(): Observable<AirlineMasterProperties[]> {
    return this.http.get<AirlineMasterProperties[]>(this.baseUrl + '/Airline/GetAirlinesAll' )
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  DeleteAirlineDetails(obj, userid): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Airline/DeleteAirline/' + obj + '/' + userid, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateAirlines(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Airline/CreateAirlineDetail', obj)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateAirlines(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Airline/UpdateAirlineDetail',obj)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAllReportTypes(): Observable<ReportTypesAgency[]> {
    return this.http.get<ReportTypesAgency[]>(this.baseUrl + '/AgencyMaster/GetAllReportTypes')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }


}
